import ForgotPasswordSent from "@/features/auth/forgot-password/components/ForgotPasswordSent";

export default function ForgotPasswordSentPage() {
  return <ForgotPasswordSent />;
}
